import styles from './Contact.module.scss'
import { useEffect, useRef } from 'react'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger)

const Contact: React.FC = () => {
  const section = useRef<HTMLElement>()
  const slide = useRef<HTMLDivElement>()

  useHubSpotGenerate('na1', '9395227', '7807f739-d2fe-421d-8662-3e12b4c4e448', '#hbspt')
  useEffect(() => {
    gsap.to(slide.current, {
      width: 0,
      duration: 0.5,
      scrollTrigger: {
        trigger: section.current,
        start: 'top-=350 top+=200',
      },
    })
  }, [])

  return (
    <>
      <section className={styles.contact} id="contact" ref={section}>
        <div className={styles.wrapper}>
          <div className={styles.top}>
            <div className={styles.title}>
              <div className={styles.slider} ref={slide}></div>
              <span>Contact</span>
              <h2>お問い合わせ</h2>
            </div>
          </div>
          <div className={`${styles.hubSpot} design_system_hubSpot`} id="hbspt"></div>
        </div>
      </section>
    </>
  )
}

export default Contact
